import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import figma from "../../assets/Images/figma.png";
import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";
import Slideshow from "../../assets/Slideshow/Slideshow"; 

import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";





const Lo4Adv = () => {
    const navigate = useNavigate();
    const images = [figma, lowprot1, lowprot2];

    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo4-headings">
                <h1>Advisory Report</h1>
                <p>I have to try make and offer recommendation for future uses</p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                                    <BreadcrumbHeader />
                        </div>
                        
            <div className="content-lo4">
                <div className="content-lo4-advisory">
                    <div className="content-lo4-advisory-text">
                    {/* <img src={gif2}></img> */}
                        <h1>3D Poster with Arduino</h1>
                        <p>
                            The interactive 3D poster concept develop for the Virtual Production minor have strong
                            potential for adaptation and reuse in future university campaigns, open days, and student
                            recruitment events. The strong value lies in combining visual design with technology to
                            capture and spark curiousity. 
                        </p>
                        <p>
                            For more information you can check the Advisory Document that
                            I tried to make here: 
                            <a 
                                href="/docs/advisoryr.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                             >Advisory Report
                             </a>
                        </p>

                        {/* <h2>Theme Based Flexibility</h2>
                        <p>
                            The structure of the concept is versitle and can be adapted to make various campaign thems not 
                            just cat memes. For example:
                            <ul>
                                <li>Gaming : Replace the 3D cat with a 3D Character, and for the sound effects we can use game sounds/ voice lines.</li>
                                <li>Film or Media Studies: Using a film reel, or miniature set as the 3D element and change the sound effects with cinematic sounds</li>
                            </ul>
                            By adjusting the 3D model and sound effects, the poster can remain interactive while making it the same with our campaign's subject.
                        </p>
                        <h2>Enhancing the Arduino Interaction</h2>
                        <p>
                            To make it more immersive and engaging, we can enhance the Arduino setup:
                            <ul>
                                <li>Adding LED lights that blink or changes color when motion is detected, could lead to drawing more visual attention.</li>
                                <li>Using touch sensor or button to let users manually trigger sounds or animations</li>
                            </ul>
                        </p>
                        <h2>Strategic Use in Events</h2>
                        <p>
                            The 3D interactive poster can be used in situation like:
                            <ul>
                                <li>University Open Days</li>
                                <li>Students Recruitment events</li>
                                <li>Pop-up events</li>
                            </ul>
                        </p>
                        <h2>Sustainability and Reusability</h2>
                        <p>
                            This project could be reuse for future events:
                            <ul>
                                <li>The Arduino components can be reprogrammed and recycle for future campaigns</li>
                                <li>The poster can be reprinted with updated visuals while still using the same 3D and sensor setup</li>
                                <li>The 3D models can be switched depending on the new theme or campaign</li>
                            </ul>
                        </p> */}
                    </div>

                    {/* <div className="content-lo4-advisory-slideshow">
                        <Slideshow images={images} />

                    </div> */}

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo4Adv;